<template>
  <div>
    <ModalConfirm modalId="paidModal" :text="`Are you sure to ${statusModal} this order?`" :center="true"
      @onClick="handleModalConfirm" />
    
    <TemplateModal :show="showModalReason" @handleClose="showModalReason=false" :center="true">
      <div class="modal-content">
        <div class="modal-header">
          <p class="fw-bold modal-title fsize-16 text-capitalize">Cancel Order</p>
        </div>
        <div class="modal-body pb-0">
          <div class="row mb-2">
            <label class="col-lg-12 ms-2 form-label fw-bold text-start">
              Enter cancel reason
            </label>
            <div class="col-lg-12">
              <textarea class="form-control m-2" rows="5" v-model="reason" style="width: 98%;"></textarea>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-center mb-3">
          <button type="button"
            class="btn btn-secondary bg-white border border-danger text-danger rounded ms-4 me-3 w-50"
            @click="showModalReason=false">Cancel</button>
          <button type="button" class="btn btn-danger text-white shadow-sm rounded w-50 me-4 text-uppercase"
            @click="changeStatus()">Confirm</button>
        </div>
      </div>
    </TemplateModal>
    <TemplateModal :show="showForceShippingModal" @handleClose="showForceShippingModal=false">
      <div class="modal-content">
        <div class="modal-header">
          <p class="fw-bold modal-title">Force Shipping</p>
        </div>
        <div class="modal-body m-3">
          <div class="d-flex flex-column">
            <div class="row">
              <label class="col-lg-12 col-form-label text-start">
                Enter AWB
              </label>
              
              <div :key="index" v-for="(item, index) in orderPackage" class="col-md-12 mb-2">
                <input type="text" v-model="awb[index]" class="form-control" />
                <span v-if="forceShippingErrors[index]" class="text-danger mt-3">{{ forceShippingErrors[index] }}</span>
              </div>

              <div class="flex">
                <div class="alert alert-warning mb-3" v-show="isDropShip">
                  <img src="@/assets/ic_info_yellow.png" alt="icon-info" />
                  <span>
                    This is a <b>Dropshipper Order</b>. Please make sure Sender Name
                    and Sender Phone Number on the new Printed AWB are as per
                    requested, if any.
                  </span>
                </div>
  
                <div class="alert alert-warning my-4" :style="{padding: '5px 12px'}" role="alert" v-if="orderPackage.length > 1">
                  <font-awesome-icon icon="fa-solid fa-circle-info" class="me-1 text-warning" />
                  This order will have multiple shipments (Split AWB)
                </div>
              </div>
            </div>
          </div>
          <div class="flex mt-3">
            <div class="d-flex col-md-12">
              <div class="col-md-6 me-3">
                <button type="button" class="btn btn-secondary bg-white text-body fw-bold me-1 text-uppercase col-md-11" @click="showForceShippingModal=false">Cancel</button>
              </div>
              <div class="col-md-6 ms-2">
                <button type="button" :disabled="awb.filter((item) => { return item !== ''}).length !== orderPackage.length" class="btn btn-danger fw-bold text-white text-uppercase col-md-11" @click="submitForceShipping()">Force Shipping</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </TemplateModal>
    <div class="modal fade" id="modalCreateShipment" tabindex="-1" aria-labelledby="exampleModalLabel"
      aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <p class="fw-bold modal-title fsize-16" id="exampleModalLabel">{{deliveryType === "instant" ? "Request Instant Driver" : "Request Pickup"}}</p>
          </div>
          <div class="modal-body m-3">
            <div class="row">
              <label class="col-lg-12 col-form-label text-start">
                Receiver
              </label>
            </div>
            <div class="row fw-bold">
              <label class="col-lg-12 col-form-label text-start">
                {{buyer_name}}
              </label>
              <label class="col-lg-12 col-form-label text-start">
                {{address}}
              </label>
            </div>
            <div class="row mb-3">
              <GMapMap :center="center" :zoom="16" class="ms-1" map-type-id="terrain" ref="myMapRef"
                :cluster="{ options: { styles: clusterStyle } }" style="width: 460px; height: 200px" :options="{
                  fullscreenControl: false,
                  styles: mapStyle,
                  mapTypeControl: false,
                  streetViewControl: false,
                  keyboardShortcuts: false,
                  controlSize: 23,
                }">
                  <GMapMarker :key="index" v-for="(m, index) in markers" :position="m.position"
                    :icon="require(`@/assets/images/paxel-marker.svg`)" />
              </GMapMap>
            </div>
            <template v-if="deliveryType != 'instant'">
              <div class="row">
                <label class="col-lg-12 col-form-label text-start">
                  Pickup Date
                </label>
                <div class="col-md-12">
                  <select v-model="pickup_date"  class="form-control" :style="time_slot.value == null ?'color:red':''">
                    <option v-for="item in dateSlot" :key="item" :value="item.value" style="color:black" :style="item.timeslot == null ?'color:red !important':''">{{item.label}} </option>
                  </select>
                </div>
              </div>
              <div class="row">
                <label class="col-lg-12 col-form-label text-start">
                  Time Slot
                </label>
                <div class="col-md-12">
                  <select v-model="time_slot.value"  class="form-control" :style="time_slot.value == null ?'color:red':''" :disabled="!pickup_date">
                    <option v-for="item in timeSlot" :key="item.label" :value="item.value" :style="item.value == null ?'color:red':''">{{item.label}}</option>
                  </select>
                </div>
              </div>
            </template>
            <div class="alert alert-warning my-4" :style="{padding: '5px 12px'}" role="alert" v-if="multipleShipment">
              <font-awesome-icon icon="fa-solid fa-circle-info" class="me-1 text-warning" />
              This order will have multiple shipments (Split AWB)
            </div>
            <div class="row mt-3">
              <div class="d-flex col-md-12">
                <div class="col-md-6 me-3">
                  <button type="button"
                    class="btn btn-secondary bg-white text-body fw-bold me-1 text-uppercase col-md-11"
                    data-bs-dismiss="modal">Cancel</button>
                </div>
                <div class="col-md-6 ms-2">
                  <button
                    type="button"
                    :class="deliveryType!='instant' && (!time_slot?.value || !pickup_date) ? 'disabled' : ''"
                    class="btn btn-danger fw-bold text-white text-uppercase col-md-11"
                    data-bs-dismiss="modal"
                    @click="createAWB"
                  >
                    {{deliveryType == 'instant'?'Order Driver':'Request Pickup'}}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <TableBasic :payload="payload" @onChange="changeParameter">
      <template v-slot:child_order_id="{ data }">
        <div>
          <router-link
            :to="'/order/orders/' + data.id +'?detail=processed&type_order=orderseller'"
            class="text-decoration-none fw-bold"
            style="color: #5e50a1"
          >
            {{ data.id }}
          </router-link>
        </div>
      </template>
      <template v-slot:buyer_name="{ value }">
        <div class="fw-bold" style="color: #5e50a1">
          {{ value }}
        </div>
      </template>
      <template v-slot:seller_store_name="{ value }">
        <div class="fw-bold" style="color: #5e50a1">
          {{ value }}
        </div>
      </template>
      <template v-slot:total_order="{ data }">
        <div>
          {{ filters.rupiah(data.order_seller_pricing.total_payment ) }}
        </div>
      </template>
      <template v-slot:created_date="{ value }">
        <div>
          {{ filters.dateFull(value) }}
        </div>
      </template>
      <template v-slot:actions="{ data }">
        <div class="d-flex">
          <div>
            <button type="button" class="btn btn-danger text-white fw-bold border mb-2" @click="setData(data,'SELLER_CANCELLED')"
              data-bs-toggle="modal" data-bs-target="#paidModal">
              <font-awesome-icon icon="fa-solid fa-xmark" class="mr-2" /> Cancel
            </button>
            <button type="button" class="btn btn-light text-danger fw-bold border border-danger mb-2" data-bs-toggle="modal"
              data-bs-target="#modalCreateShipment" @click="initiatePickup(data)">
              Request Pickup {{ data.service_type.toLowerCase() == 'instant'?'Instant':'Nextday' }}
            </button>
          </div>
          <div class="ms-auto">
            <button class="btn" v-if="!data.additional_row" @click="data.additional_row = !data.additional_row">
              <font-awesome-icon icon="fa-solid fa-sort-down" class="mb-1 text-warning" />
            </button>
            <button class="btn mt-3 align-middle" v-if="data.additional_row"
              @click="data.additional_row = !data.additional_row">
              <font-awesome-icon icon="fa-solid fa-sort-up" class="mb-1 text-warning" />
            </button>
          </div>
        </div>
      </template>

      <template v-slot:seller_process_deadline_pickup="{ data, value }">
        <div class="mb-5">
          <span class="text-black-50">
            Automatically Cancelled if Pickup not yet requested by
          </span>
          <br />
          <span class="fw-bold">
            {{ filters.dateFull(value) }}
          </span>
          <br/>
          <span
            v-if="data.attempt_shipping > 0"
            class="fw-bold text-danger"
            style="cursor: pointer"
            @click="forceShipping(data)"
          >
            Force Shipping
          </span>
          <span
            v-else
            style="cursor: pointer"
            class="text-black-50 fw-bolder"
          >
            Force Shipping
          </span>
        </div>
      </template>
      <template v-slot:parent_order_id="{ data }">
        <div>
          <span class="text-black-50"> Parent Order ID </span>
          <br />
          <span class="text-secondary fw-bold">{{ data.order_id }}</span>
        </div>
      </template>
      <template v-slot:location_destination="{ data, value }">
        <div v-if="value">
          <font-awesome-icon icon="fa-solid fa-location-dot" class="pe-2 text-secondary" />
          <span class="fw-bold text-secondary">{{ value.city }}</span>
          <br />
          <span class="text-black-50"> Shipment Cost </span>
          <br />
          <span class="fw-bold">{{ filters.rupiah(data.order_seller_pricing.shipment_cost) }}</span>
        </div>
      </template>
      <template v-slot:location_origin="{ value }">
        <div v-if="value">
          <font-awesome-icon icon="fa-solid fa-location-dot" class="pe-2 text-secondary" />
          <span class="fw-bold text-secondary">{{ value.city }}</span>
          <br />
        </div>
      </template>
      <template v-slot:product="{ data }">
        <div>
          <span class="fw-bold mb-1"
            style="color: #5e50a1">{{ data.product_items.length > 0 ? `${data.product_items.length} Products` : '' }}</span>
        </div>
      </template>
    </TableBasic>
  </div>
</template>

<script>
  import TableBasic from "@/components/TableBasic.vue";
  import TemplateModal from "@/components/TemplateModal.vue";
  import moment from "moment"

  export default {
    components: {
      TableBasic,
      TemplateModal
    },
    data() {
      return {
        payload: {
          filter: true,
          filterLabel: "Filter by Created date",
          datepickerOption: {
            autoApply: true,
            timePicker: false,
          },
          header: [{
              key: "child_order_id",
              label: "C. ORDER ID",
              class: "text-start",
            },
            {
              key: "buyer_name",
              label: "BUYER",
              class: "text-start",
            },
            {
              key: "seller_store_name",
              label: "SELLER",
              class: "text-start",
            },
            {
              key: "total_order",
              label: "TOTAL ORDER",
              class: "text-start",
              sort: true,
              sort_key: 'order_seller_pricing.total_payment'
            },
            {
              key: "created_date",
              label: "CREATED DATE",
              class: "text-start",
              sort: true,
              sort_key: 'created_date'
            },
            {
              key: "actions",
              label: "ACTIONS",
              class: "text-start",
            },
          ],
          second_header: [{
              key: "parent_order_id",
              label: "Child Order ID",
              class: "text-start",
            },
            {
              key: "location_destination",
              label: "",
              class: "text-start",
            },
            {
              key: "location_origin",
              label: "",
              class: "text-start",
            },
            {
              key: "product",
              label: "",
              class: "text-start",
            },
            {
              key: "",
              label: "",
              class: "",
            },
            {
              key: "seller_process_deadline_pickup",
              label: "",
              class: "text-start",
            },
          ],
          value: [],
          totalRows: 1,
          checkbox: true,
          currentPage: 1,
          perPage: 10,
          pageOptions: [10, 20, 50, 100],
          search: true,
          startDate: "",
          endDate: "",
          searchPlaceholder: "Parent/Child Order ID/Buyer/Seller",
          searchContainerStyle: { maxWidth: '235px' },
          sortBy: "",
          sortType: "",

        },
        selectedOrder: {},
        buyer_name: "",
        address: "",
        time_slot: {},
        pickup_date: "",
        multipleShipment: false,
        filterValue: {},
        dateSlot: [],
        timeSlot: [],
        mapStyle: [],
        center: {
          lat: -6.2,
          lng: 106.8456
        },
        markers: [{
          position: {
            lat: -6.2,
            lng: 106.8456
          }
        }],
        clusterStyle: [{
          url: "https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m1.png",
          width: 56,
          height: 56,
          textColor: "#fff",
        }],
        isDropShip: false,
        showForceShippingModal: false,
        forceShippingErrors: [],
        orderPackage: [],
        orderSellerId: '',
        awb: [],
        deliveryType:'sameday',
        statusModal: "Cancel",
        showModalReason: false,
        reason: "",
        selected: {},
      };
    },
    watch: {
      pickup_date(value) {
        if(value){
          let timeSlotTemp = this.dateSlot.find(x => x.value == value)?.timeslot
          if(timeSlotTemp?.length > 0){
            this.time_slot = {
              value: timeSlotTemp[0],
              label: timeSlotTemp[0].split(" - ").map(x=>{
                  return x.substring(0,5)
                }).join(" - ")
            }
            this.timeSlot = timeSlotTemp.map(time=>{
              return {
                value: time,
                label : time.split(" - ").map(x=>{
                  return x.substring(0,5)
                }).join(" - ")
              }
            })
          } else {
            this.time_slot = {
              value: null,
              label: "Ops. Libur"
            }
            this.timeSlot = [{
              value: null,
              label: "Ops. Libur"
            }]
          }
        }
      }
    },
    methods: {
      async forceShipping(orderSeller) {
        this.awb = []
        this.forceShippingErrors = []
        this.showForceShippingModal = true
        this.orderPackage = orderSeller.order_packages
        this.orderSellerId = orderSeller.id
        
        if (orderSeller.is_dropshipper) {
          this.isDropShip = true
        }
      },
      async submitForceShipping() {
        try {
          const payload = {
            order_seller_id: this.orderSellerId,
            airway_bill: this.awb
          }
          
          await this.$store.dispatch("order/forceShipping", payload);

          this.$swal({
            icon: "success",
            title: "Success force shipping.",
            showConfirmButton: false,
            timer: 1500,
          }).then(() => {
            this.showForceShippingModal = false
            /* https://pmtools.paxel.co/issues/244 disable auto redirect to next status, refresh table data only */
            // this.$router.push("/order/orders?status=On%20Shipment" )
            this.getData();
          })
        } catch (error) {
          if (error.response?.data?.errorMessage) {
            const errorSplit = error.response?.data?.errorMessage.split(", ")
            
            if (errorSplit.length === 1) {
              if (errorSplit[0] === 'Invalid AWB') {
                this.forceShippingErrors = errorSplit
              } else {
                console.error('error not invalid awb')
                this.$swal({
                  title: error.response?.data?.errorMessage,
                  icon: "warning",
                  timer: 2000,
                })
              }
            } else {
              this.forceShippingErrors = errorSplit
            }
          } else {
            this.$swal({
              title: error.message,
              icon: "warning",
              timer: 2000,
            })
          }
        }
      },
      changeParameter(value) {
        this.payload.perPage = value.per_page;
        this.payload.currentPage = value.current_page;
        this.payload.toPage = value.next_page;
        this.payload.sortType = value.sort_type
        this.payload.sortBy = value.sort_by
        this.searchInput = value.search;
        this.filterValue = value.filter;
        this.getData();
      },
      async getData() {
        let payload = {
          page: this.payload.currentPage,
          size: this.payload.perPage,
          status: "SELLER_CONFIRMED"
        };

        if (this.filterValue) {
          console.log(this.filterValue);
          payload.date_start = this.filterValue.from;
          payload.date_end = this.filterValue.to;
        }

        if(this.payload.sortBy) payload.sort_by = this.payload.sortBy
        if(this.payload.sortType) payload.sort_type = this.payload.sortType

        if (this.searchInput != "") {
          payload.keyword = this.searchInput;
        }

        const response = await this.$store.dispatch("order/getAllOrderSeller", payload);
        this.payload.value = response.items;
        this.payload.totalRows = response.count;
      },
      async initiatePickup(data) {
        const orderPackage = data?.order_packages?.[0]
        const payload = {
          "order_seller_id": data.id
        }

        this.selectedOrder = data
        this.deliveryType = data.service_type.toLowerCase()
        this.buyer_name = orderPackage.location_destination.name_person
        this.address =
          `${orderPackage.location_destination.address_detail}, ${orderPackage.location_destination.district} ${orderPackage.location_destination.city} ${orderPackage.location_destination.province}`
        this.center = {
          lat: orderPackage.location_destination.lat_lng[0],
          lng: orderPackage.location_destination.lat_lng[1]
        }

        this.markers = [{
          position: {
            lat: orderPackage.location_destination.lat_lng[0],
            lng: orderPackage.location_destination.lat_lng[1]
          }
        }]

        this.multipleShipment = Boolean(data?.order_packages?.length > 1)

        // reset form
        this.time_slot = {}
        this.pickup_date = ""

        try {
          console.log("PAYLOAD")
          console.log(payload)
          const res = await this.$store.dispatch("order/getTmeSlot", payload)
          
          this.dateSlot = res.map(x=> ({
              value: x.date,
              label: moment(x.date).format("DD MMM YYYY"),
              timeslot: x.timeslot
          }))

        } catch (err) {
          console.log(err)
        }
      },
      async createAWB() {
        let pickup_datetime = "";
        if(this.deliveryType != "instant"){
          var timeslot = this.time_slot.value.split(" - ");
          pickup_datetime =  `${this.pickup_date} ${timeslot[0]}`
        }else{
          pickup_datetime = moment(new Date).add(1,'minutes').locale("Id").format('YYYY-MM-DD HH:mm:ss'); //add 1 minutes as buffer process so pickup > created at
        }
        const payload = {
          "order_seller_id" : this.selectedOrder.id,
          "payment_type" : "CRD",
          "is_high_value": false,
          "pickup_datetime":pickup_datetime,
          "need_insurance": false,
          "note": "",
          "is_dropship": false,
          "dropshipper": null, 
          "service_type": this.deliveryType.toUpperCase()
        }

        try {
          await this.$store.dispatch("order/createAWB", payload)

          setTimeout(() => {
            this.showMessage = false
            /* https://pmtools.paxel.co/issues/244 disable auto redirect to next status, refresh table data only */
            // this.$router.push("/order/orders?status=On%20Shipment" )
            this.getData();
          }, 500);
        } catch (error) {
          console.log("ERROR : ", error)
          this.$swal({
            title: error.response?.data?.errorMessage || error.message,
            icon: "warning",
            timer: 2000,
          }).then(() => {
            this.getData();
          })
        }
      },
      setData(data, status) {
        this.selected = data
        this.reason = ""
        this.showModalReason = true
      },
      async changeStatus() {
        const payload = {
          "order_seller_id": this.selected.id,
          "reason": this.reason || ""
        }
        try {
          await this.$store.dispatch("order/cancelOrderSellerViaBuyerApi", payload)
          setTimeout(() => {
            this.showMessage = false;
            this.showModalReason = false;
            this.getData();
            this.$swal({
              title: "success cancel order",
              icon: "success",
              timer: 2000,
            })
          }, 500);
        } catch (error) {
          console.log("ERROR : ", error)
          this.showModalReason = false;
          this.$swal({
            title: error.response?.data?.errorMessage || error.message,
            icon: "warning",
            timer: 2000,
          })
        }
      }
    },
    mounted() {
      this.getData();
    },
  };
</script>

<style></style>
